import { useRef, useState, useEffect } from "react";

function AudioPlayer() {
  const audioRef = useRef(null);
  const progressRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [volume, setVolume] = useState(1);
  const [progress, setProgress] = useState(0);

  // Play / Pause toggle
  const togglePlay = () => {
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setPlaying(!playing);
  };

  // Update progress bar
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const updateProgress = () => {
      const percent = (audio.currentTime / audio.duration) * 100;
      setProgress(percent || 0);
    };

    audio.addEventListener("timeupdate", updateProgress);

    return () => audio.removeEventListener("timeupdate", updateProgress);
  }, []);

  // Seek audio
  const handleSeek = (e) => {
    const audio = audioRef.current;
    const width = e.target.clientWidth;
    const clickX = e.nativeEvent.offsetX;
    const duration = audio.duration;

    audio.currentTime = (clickX / width) * duration;
  };

  // Volume control
  const handleVolume = (e) => {
    const audio = audioRef.current;
    const value = parseFloat(e.target.value);
    audio.volume = value;
    setVolume(value);
  };

  return (

          <div className="innersec container my-5">
    <div className="audio-player">
      <audio ref={audioRef} loop>
        <source
          src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/school_song.mp3"
          type="audio/mpeg"
        />
        Your browser does not support the audio element.
      </audio>

      <div className="controls">
        <button id="play-pause" onClick={togglePlay}>
          {playing ? "❚❚" : "►"}
        </button>

        <div
          className="progress-container"
          id="progress-container"
          onClick={handleSeek}
        >
          <div
            className="progress"
            id="progress"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        <input
          type="range"
          id="volume"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={handleVolume}
        />
      </div>
    </div>
          <div className="row g-3">
          <div className="col-lg-6">
            <h1> School Prayer  </h1>
            <div class="schoolsong">
              <div class="schoolsongbox">
                <p>
                  O God, help us to be gentle, walking softly with one another.
                  Help us to be understanding, lest we should add to the world's sorrow
                  or cause to flow one needless tear.
                  <br />
                  Help us to stand for what is right, not because we may gain by it,
                  but because it is right.
                  <br />
                  Help us to be as anxious for the rights of others as we are for our own.
                  <br />
                  Help us to be eager to forgive others as we are to ask forgiveness.
                </p>

                <p><strong>Prayer for the School</strong></p>

                <p>
                  Prosper with Thy blessing, we beseech Thee, O Lord, the work of this our school,
                  and grant that those who serve Thee here may set Thy holy will ever before them
                  and do that which is well pleasing in Thy sight.
                  <br />
                  Prosper with Thy blessing, we beseech Thee, O Lord, the work of this our school,
                  and grant that those who serve Thee here may set Thy holy will ever before them
                  and do that which is well pleasing in Thy sight.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <h1>School Song </h1>
            <div class="schoolsong">
              <div class="schoolsongbox">
                <p>May all we learn here in our school,<br />
                  By thought and deed be shown,<br />
                  Let living truth within us rule,<br />
                  And seeds of love be sown:<br />
                  That men in all our deeds may see<br />
                  Courage is Destiny!<br />
                  Courage is Destiny!</p>

                <p>We pray for grace, serenity,<br />
                  To keep a humble mind,<br />
                  That we may learn thru’ charity,<br />
                  To love all humankind:<br />
                  That men in all our deeds may see<br />
                  Courage is Destiny!<br />
                  Courage is Destiny!</p>

                <p>Undaunted, though alone we stand,<br />
                  Upholding what is right,<br />
                  Proud children of our Motherland,<br />
                  With truth our stay and might:<br />
                  That men in all our deeds may see<br />
                  Courage is Destiny!<br />
                  Courage is Destiny!</p>


                <p>All that is good may we retain,<br />
                  When scattered far and wide,<br />
                  May we our destiny attain,<br />
                  With Courage as our guide:<br />
                  To show that by our constancy<br />
                  Courage is Destiny!<br />
                  Courage is Destiny!</p>

              </div>
            </div>
          </div>
        </div>


</div>


  );
}

export default AudioPlayer;
